import React, { useCallback, useState,useRef } from "react";
import { useHistory } from 'react-router-dom';
import DropDownButton from "devextreme-react/drop-down-button";
import "devextreme/data/odata/store";
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { Button } from 'devextreme-react/button';
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  Item,
  Toolbar,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  Selection,
  StateStoring
} from "devextreme-react/data-grid";
import _ from "lodash";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
const buttonDropDownOptions = { width: 140 };
export default (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  const onSelectionChanged = ({ selectedRowsData }) => {
    const selectedData = selectedRowsData[0];
    if (selectedRowsData.length === 1) {
      props.parentCallback(selectedData);
      props.enableDisableLocBtn(false);
      props.enableDisableStatusBtn(false);
      props.enableDisableSrlNumber(false);
    }
    else
      return;
  };
  const onItemClick = (e) => {
    console.log(e.itemData);
    switch (e.itemData.name) {
      case 'Lots':
        history.push({
          pathname: '/wm/inventory-lots',
          state: { detail: e.itemData.itemRowid }
        });
        break;
      case 'Sub Lots':
        history.push({
          pathname: '/wm/inventory-sublots',
          state: { detailItemRowid: e.itemData.itemRowid }
        });
        return;
      default:
        return;
    }
  }

  const allowedPageSizes = [10, 20, 100, 300];

  const gridKey = "7fc24a0f-1a92-4e1d-b01a-556979ac0011";
  const [currentLayout, setCurrentLayout] = useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", props.accessToken,null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", props.accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        dataSource={props.data}
        showBorders={true}
        className={props.searchPanelStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        columnAutoWidth={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
        remoteOperations={true}
        onSelectionChanged={onSelectionChanged}
      >
        <Selection mode="single" />
        <ColumnChooser enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting visible={true} mode="multiple" />
        <LoadPanel enabled={true} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column
          dataField="rowid"
          caption=""
          cellRender={(rowid) => cellRender(rowid)}
        />
        <Column dataField="itemCode" caption={Localization.formatMessage('IMITEM.ITEMCODE', 'Item Code')}></Column>
        <Column dataField="itemDescription1" caption={Localization.formatMessage('IMITEM.DESCRIPTION_1', 'Item Description 1')}></Column>
        <Column dataField="itemDescription2" caption={Localization.formatMessage('IMITEM.DESCRIPTION_2', 'Item Description 2')}></Column>
        <Column dataField="classCode" caption={Localization.formatMessage('IMITEM.CLASSCODE', 'Item Class')}></Column>
        <Column dataField="comment" caption={Localization.formatMessage('IMITEM.COMMENT', 'Comment')}></Column>
        <Column dataField="itemAvailable" caption={Localization.formatMessage('IMITEM.IMLOCATIONQUANTITYSUMMARY', 'Avaialble')}></Column>
        <Column dataField="subClassCode" caption={Localization.formatMessage('IMITEM.SUBCLASSCODE', 'Sub Class Code')} visible={false}></Column>
        <Column dataField="UDFComment" caption={Localization.formatMessage('IMITEM.USERDEFINEDCOMMENT', 'User Defined Comment')} visible={false}></Column>
        <Column dataField="itemUDFCode1" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_1', 'Code 1')} visible={false}></Column>
        <Column dataField="itemUDFCode2" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_2', 'Code 2')} visible={false}></Column>
        <Column dataField="itemUDFCode3" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_3', 'Code 3')} visible={false}></Column>
        <Column dataField="itemUDFCode4" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_4', 'Code 4')} visible={false}></Column>
        <Column dataField="itemUDFCode5" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_5', 'Code 5')} visible={false}></Column>
        <Column dataField="itemUDFCode6" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_6', 'Code 6')} visible={false}></Column>
        <Column dataField="itemUDFCode7" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_7', 'Code 7')} visible={false}></Column>
        <Column dataField="itemUDFCode8" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_8', 'Code 8')} visible={false}></Column>
        <Column dataField="itemUDFCode9" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_9', 'Code 9')} visible={false}></Column>
        <Column dataField="itemUDFCode10" caption={Localization.formatMessage('IMITEM.USERDEFINEDCODE_10', 'Code 10')} visible={false}></Column>
        <Column dataField="itemUDFRef1" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_1', 'Reference 1')} visible={false}></Column>
        <Column dataField="itemUDFRef2" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_2', 'Reference 2')} visible={false}></Column>
        <Column dataField="itemUDFRef3" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_3', 'Reference 3')} visible={false}></Column>
        <Column dataField="itemUDFRef4" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_4', 'Reference 4')} visible={false}></Column>
        <Column dataField="itemUDFRef5" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_5', 'Reference 5')} visible={false}></Column>
        <Column dataField="itemUDFRef6" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_6', 'Reference 6')} visible={false}></Column>
        <Column dataField="itemUDFRef7" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_7', 'Reference 7')} visible={false}></Column>
        <Column dataField="itemUDFRef8" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_8', 'Reference 8')} visible={false}></Column>
        <Column dataField="itemUDFRef9" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_9', 'Reference 9')} visible={false}></Column>
        <Column dataField="itemUDFRef10" caption={Localization.formatMessage('IMITEM.USERDEFINEDREFERENCE_10', 'Reference 10')} visible={false}></Column>
        <Column dataField="itemUDFDate1" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_1', 'Date 1')} visible={false}></Column>
        <Column dataField="itemUDFDate2" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_2', 'Date 2')} visible={false}></Column>
        <Column dataField="itemUDFDate3" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_3', 'Date 3')} visible={false}></Column>
        <Column dataField="itemUDFDate4" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_4', 'Date 4')} visible={false}></Column>
        <Column dataField="itemUDFDate5" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_5', 'Date 5')} visible={false}></Column>
        <Column dataField="itemUDFDate6" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_6', 'Date 6')} visible={false}></Column>
        <Column dataField="itemUDFDate7" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_7', 'Date 7')} visible={false}></Column>
        <Column dataField="itemUDFDate8" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_8', 'Date 8')} visible={false}></Column>
        <Column dataField="itemUDFDate9" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_9', 'Date 9')} visible={false}></Column>
        <Column dataField="itemUDFDate10" dataType="date" caption={Localization.formatMessage('IMITEM.USERDEFINEDDATE_10', 'Date 10')} visible={false}></Column>
        <Column dataField="itemUDFQty1" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_1', 'Quantity 1')} visible={false}></Column>
        <Column dataField="itemUDFQty2" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_2', 'Quantity 2')} visible={false}></Column>
        <Column dataField="itemUDFQty3" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_3', 'Quantity 3')} visible={false}></Column>
        <Column dataField="itemUDFQty4" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_4', 'Quantity 4')} visible={false}></Column>
        <Column dataField="itemUDFQty5" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_5', 'Quantity 5')} visible={false}></Column>
        <Column dataField="itemUDFQty6" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_6', 'Quantity 6')} visible={false}></Column>
        <Column dataField="itemUDFQty7" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_7', 'Quantity 7')} visible={false}></Column>
        <Column dataField="itemUDFQty8" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_8', 'Quantity 8')} visible={false}></Column>
        <Column dataField="itemUDFQty9" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_9', 'Quantity 9')} visible={false}></Column>
        <Column dataField="itemUDFQty10" caption={Localization.formatMessage('IMITEM.USERDEFINEDQUANTITY_10', 'Quantity 10')} visible={false}></Column>
        <Column dataField="itemOnHand" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.ON_HAND', 'On Hand')} visible={false}></Column>
        <Column dataField="itemInReceiving" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_RECEIVING', 'In Receiving')} visible={false}></Column>
        <Column dataField="itemOutShipped" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_SHIPPED', 'Out Shipped')} visible={false}></Column>
        <Column dataField="itemOutUnAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_UNAVAILABLE', 'Out Unavailable')} visible={false}></Column>
        <Column dataField="itemInOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_ORDERED', 'In Ordered')} visible={false}></Column>
        <Column dataField="itemOutOrdered" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_ORDERED', 'Out Ordered')} visible={false}></Column>
        <Column dataField="itemNetAvailable" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.NETAVAILABLE', 'Net Available')} visible={false}></Column>
        <Column dataField="itemInFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.IN_FUTURE', 'In Future')} visible={false}></Column>
        <Column dataField="itemOutFuture" caption={Localization.formatMessage('IMLOCATIONQUANTITYSUMMARY.OUT_FUTURE', 'Out Future')} visible={false}></Column>
        <Column dataField="itemPiecesPerUnitQty" caption={Localization.formatMessage('IMITEM.PIECESPERUNITQUANTITY', 'Pieces per Unit Qty')} visible={false}></Column>
        <Column dataField="itemUnitPerPckgQty" caption={Localization.formatMessage('IMITEM.UNITSPERPACKAGEQUANTITY', 'Unit per Pckg Qty')} visible={false}></Column>
        <Column dataField="itemPackagesPerShipUnitQty" caption={Localization.formatMessage('IMITEM.PACKAGESPERSHIPPINGUNITQTY', 'Pckg per Ship Unit Qty')} visible={false}></Column>
        <Column dataField="itemStatus" caption={Localization.formatMessage('IMITEM.STATUS', 'Status')} visible={false}></Column>
        <Column dataField="itemSize1" caption={Localization.formatMessage('IMITEM.SIZE_1', 'Size 1')} visible={false}></Column>
        <Column dataField="itemSize2" caption={Localization.formatMessage('IMITEM.SIZE_2', 'Size 2')} visible={false}></Column>
        <Column dataField="itemNetWeightQty" caption={Localization.formatMessage('IMITEM.NETWEIGHTQUANTITY', 'Unit Net Wt')} visible={false}></Column>
        <Column dataField="itemGrossWeightQty" caption={Localization.formatMessage('IMITEM.GROSSWEIGHTQUANTITY', 'Unit Gross Wt')} visible={false}></Column>
        <Column dataField="OEMManufacturerCode" caption={Localization.formatMessage('IMITEM.OEMMANUFACTURERCODE', 'OEM Manuf Code')} visible={false}></Column>
        <Column dataField="customerName" caption="Customer Name" visible={false}></Column>
        <Column dataField="customerCode" caption="Customer Code" visible={false}></Column>
        <Toolbar>
          <Item location="before">
            <Button
              disabled={props.locbtnDisable}
              type="default"
              onClick={props.openLocations}
              text="Location"
            >
            </Button>
          </Item>
          <Item location="before">
            <Button
              disabled={props.SerialNumberBtnDisable}
              type="default"
              className="gridTopButton"
              onClick={props.openSerialnumberPopUp}
              text="Serial Numbers"
            >
            </Button>
          </Item>
          <Item location="before">
            <Button
              disabled={props.statusbtnDisable}
              type="default"
              className="gridTopButton"
              onClick={props.openStatus}
              text="Status"
            >
            </Button>
          </Item>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>

      </DataGrid>
    </div>
  );
  function cellRender(dta) {
    return (
      <DropDownButton
        height="auto"
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          { name: "Lots", tab: 0, itemRowid: dta.data.itemRowid },
          { name: "Sub Lots", tab: 1, itemRowid: dta.data.itemRowid }
        ]}
        displayExpr="name"
        keyExpr="rowId"
        onItemClick={onItemClick}
      />
    );
  }
};
